export default "__VITE_ASSET__2d325a93__"